const craftsman_task = {
	name: 'Craftsman Task | Craftsman Tasks',
	icon: 'fas fa-hammer',
	fields: {
		hp_id: 'ID',
		building: {
			name: '@:entity.building.name',
		},
		first_unit: {
			position: '@:entity.unit.fields.position',
		},
		to_occur: '@:common.toOccur',
		craftsman_person: '@:component.craftsmanTasks.craftsman',
		subject_type: 'Type',
		subject: '@:common.subject',
		status: {
			name: 'Status',
		},
	},
	revisionFields: {
		subject_type: 'Type',
		subject: '@:common.subject',
		craftsman_person: '@:component.craftsmanTasks.craftsman',
		status: '@:common.status',
		team: 'Team member',
		type: 'Task type',
		process: '@:component.craftsmanTasks.process',
		to_occur: '@:common.toOccur',
		deadline: '@:common.deadline',
		finished: 'Completed on',
		estimated_price: '@:component.craftsmanTasks.estimated_price',
		bill_price: 'Invoice amount',
		hp: 'ID',
		synced_at: 'Synced at',
		// AAR-1812/1813: labels for the *_removed deletion markers written by
		// CraftsmanTaskAssociationRevisionObserver (hard-deleted associations that
		// land as a change line on the craftsman task itself).
		person_removed: 'Person removed',
		contact_removed: 'Contact person removed',
		document_removed: 'Document removed',
		building_removed: 'Property removed',
		unit_removed: 'Unit removed',
		record_removed: 'File removed',
		cis_removed: 'Z.I.S. Note removed',
		task_removed: 'Reminder removed',
	},
}

export default craftsman_task
